import { formatMetaMoney } from '../metaAdsMoney';
import { formatMetaCount, metaPlural } from '../metaFormat';

/** Monto de costo (2 decimales hasta 100) / de gasto (sin decimales desde 100). */
export const metaCostText = (amount, currency) => formatMetaMoney(amount, currency, { fixed2: true });

/** Campaña elegida en el selector, o '' si ya no está en la lista (Todas las campañas). */
export const validMetaScope = (campaigns, scopeCampaignId) => (
  scopeCampaignId && (campaigns || []).some((c) => c.id === scopeCampaignId) ? scopeCampaignId : ''
);

/** Barras proporcionales al mayor valor (0..1). */
export const metaFractions = (values) => {
  const max = Math.max(0, ...values.map((v) => v || 0));
  return values.map((v) => (max > 0 ? (v || 0) / max : 0));
};

/**
 * «14 contactos · ARS 15,06» (contactos y costo por contacto) o, si en todo el período no hubo
 * contactos, «9.800 impresiones». El costo no se muestra con monedas mezcladas (la API lo manda null).
 */
export function metaRowValueText(row, metric, currency) {
  if (metric === 'contacts') {
    const parts = [metaPlural(row.contacts || 0, 'contacto', 'contactos')];
    if (row.costPerContact != null && currency) parts.push(metaCostText(row.costPerContact, currency));
    return parts.join(' · ');
  }
  return `${formatMetaCount(row.impressions)} impresiones`;
}
